import { Component } from '@angular/core';
import { ReportShareComponent } from '../report-share.component';

@Component({
  selector: 'app-style-expression',
  templateUrl: './style-expression.component.html',
})
export class StyleExpressionComponent extends ReportShareComponent {

  get html(): string {
    return this.report?.styleExpressionDesc?.replaceAll('\n','<br />') ?? '';
  }

}
